import * as constants from "../constants/constants";
const initialState = {
    isLoading: false,
    data: null,
    error: null,
};

export const getWasteOfEnergyReducer = (state = initialState, action) => {
    switch (action.type) {
        case constants.GET_WASTE_OF_ENERGY_START:
            return { ...state, isLoading: true, error: null, data: null };
        case constants.GET_WASTE_OF_ENERGY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                error: null,
                data: action.payload,
            };
        case constants.GET_WASTE_OF_ENERGY_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                data: null,
            };
        default:
            return { ...state };
    }
};

// export const getWasteOfEnergyListReducer = (state = initialState, action) => {
//     switch (action.type) {
//         case constants.GET_WASTE_OF_ENERGY_LIST_START:
//             return { ...state, isLoading: true, error: null, data: null };
//         case constants.GET_WASTE_OF_ENERGY_LIST_SUCCESS:
//             return {
//                 ...state,
//                 isLoading: false,
//                 error: null,
//                 data: action.payload,
//             };
//         case constants.GET_WASTE_OF_ENERGY_LIST_FAILURE:
//             return {
//                 ...state,
//                 isLoading: false,
//                 error: action.payload,
//                 data: null,
//             };
//         default:
//             return { ...state };
//     }
// };
